import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AvailabilityParsedItem } from '../availability-calendar.types';
import { shouldHideUnavailabilityCompensation } from '../helpers/get-unavailability-color';

export const usePopoverWorkRowLabel = () => {
  const { t } = useTranslation('all-platforms-common');

  return useCallback(
    (item: AvailabilityParsedItem): string => {
      const hideCompensation = shouldHideUnavailabilityCompensation(item.workerForPopover);

      switch (item.type) {
        case 'available':
          return t('availability_page.worker_available');
        case 'unavailablePaid':
          return hideCompensation
            ? t('availability-page.unavailability-chip.unavailable')
            : t('availability-page.unavailability-chip.paid');
        case 'unavailableUnpaid':
          return hideCompensation
            ? t('availability-page.unavailability-chip.unavailable')
            : t('availability-page.unavailability-chip.unpaid');
        default:
          return item.workName ?? t('availability_page.worker_busy');
      }
    },
    [t]
  );
};
